import React from "react";

export default function Phone(props: any) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M3.33334 3.33325C3.33334 2.22868 4.22877 1.33325 5.33334 1.33325H10.6667C11.7712 1.33325 12.6667 2.22868 12.6667 3.33325V12.6666C12.6667 13.7712 11.7712 14.6666 10.6667 14.6666H5.33334C4.22877 14.6666 3.33334 13.7712 3.33334 12.6666V3.33325Z" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <ellipse cx="8.00001" cy="11.9999" rx="0.666667" ry="0.666667" fill="currentColor" />
    </svg>
  )
}